<div fxLayout="column" style="padding:15px;">

    <app-page-header *ngIf="!isLoading" [title]="pageTitle" action=''></app-page-header>

    <ng-container *ngIf="isLoading then showLoading else showDetails"></ng-container>
    <ng-template #showLoading>
        <app-loading></app-loading>
    </ng-template>

    <ng-template #showDetails>
        <div fxLayout="column" fxFlex fxLayoutAlign="center center center" style="margin-top:50px;">

            <app-loading  *ngIf="isLoading"></app-loading>

            <div fxLayout="row" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;">
                <table>
                    <tr> <td style="width:170px;"><b>Τίτλος Δήλωσης:</b></td> <td>{{reports[0].formTitle}}</td> </tr>
                    <tr> <td style="width:170px;"><b>Δραστηριότητα:</b></td> <td>{{reports[0].activityDescription}}</td> </tr>
                </table>
            </div>

            <div fxLayout="row" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%; margin-top:20px;">
                <div> Η δήλωση εστάλη σε <span style="font-size:24px;">{{reports.length}}</span> αποδέκτες</div>
            </div>

            <div fxLayout="column" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;" style="margin-top:70px;">
                <!--      <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif"><b>{{questionTitle}}</b></div>-->

                <div fxLayout="row" fxFlex fxLayoutGap="5px">
                    <div fxFlex="33.3" fxLayout="column" class="peopleResponse" fxLayoutAlign="center center center" fxLayoutGap="5px">
                        <div fxLayout="row" class="numberedInfo">{{calculate(1)}}</div>
                        <div fxLayout="row" class="numberLabel">Συμπλήρωσαν</div>
                    </div>

                    <div fxFlex="33.3"  fxLayout="column" class="peopleResponse" fxLayoutAlign="center center center" fxLayoutGap="5px">
                        <div fxLayout="row" class="numberedInfo">{{calculate(0)}}</div>
                        <div fxLayout="row" class="numberLabel">Ακύρωσαν</div>
                    </div>

                    <div fxFlex="33.3"  fxLayout="column" class="peopleResponse" fxLayoutAlign="center center center" fxLayoutGap="5px">
                        <div fxLayout="row" class="numberedInfo">{{calculate(-1)}}</div>
                        <div fxLayout="row" class="numberLabel">Δεν απάντησαν</div>
                    </div>
                </div>
            </div>


            <div fxLayout="column" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;" style="margin-top:40px; height:450px;">
                <div fxLayout="row" fxFlex fxLayoutGap="20px">

                    <div fxLayout="column" fxFlex="50" class="info">
                        <app-report-details-side-info mode="1" [form]="currentForm"></app-report-details-side-info>
                    </div>

                    <div fxLayout="column" fxFlex="50" class="info">
                        <app-bar-chart *ngIf="!isLoading" [chartInput]="chartResults" mode="affirmations" [chartMax]="getChartMax(chartResults)"></app-bar-chart>
                    </div>

                </div>
            </div>


            <div fxFlex fxLayout="column" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;" style=" padding:20px; margin-top:50px; margin-bottom: 50px;" class="mat-elevation-z3">
                <mat-tab-group>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                Όλοι
                            </div>
                        </ng-template>

                        <div style="margin-top:20px;">
                            <app-report-affirmation-details-table [reports]="reports"></app-report-affirmation-details-table>

                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                Απάντησαν
                            </div>
                        </ng-template>

                        <div style="margin-top:20px;">
                            <app-report-affirmation-details-table [reports]="getReports(1)"></app-report-affirmation-details-table>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                Ακύρωσαν
                            </div>
                        </ng-template>
                        <div style="margin-top:20px;">
                            <app-report-affirmation-details-table [reports]="getReports(0)"></app-report-affirmation-details-table>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div fxLayout="row" fxFlex style="font-family: 'Century Gothic', sans-serif">
                                Σε αναμονή
                            </div>
                        </ng-template>
                        <div style="margin-top:20px;">
                            <app-report-affirmation-details-table [reports]="getReports(-1)"></app-report-affirmation-details-table>
                        </div>
                    </mat-tab>

                </mat-tab-group>
<!--                <div fxLayout="row" fxLayoutGap="20px" fxFlex ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:90%;">-->
<!--                    <div fxFlexAlign="center">Γρήγορη Αναζήτηση</div>-->
<!--                    <div fxFlexAlign="center" fxLayoutGap="20px" >-->
<!--                        <mat-form-field>-->
<!--                            <mat-label>Κριτήριο Αναζήτησης</mat-label>-->
<!--                            <mat-select [(ngModel)]="simpleSearchSelectedValue" (selectionChange)="criteriaChanged()">-->
<!--                                <mat-option style="font-family: 'Century Gothic', sans-serif" *ngFor="let searchField of affirmationSearchFields" [value]="searchField">{{searchField.label}}</mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field  *ngIf="simpleSearchSelectedValue && simpleSearchSelectedValue.type === 'text'">-->
<!--                            <mat-label>Κριτήριο</mat-label>-->
<!--                            <input matInput [(ngModel)]="searchValue" (keydown)="fastSearch($event) ">-->
<!--                        </mat-form-field>-->




<!--                        <mat-form-field  *ngIf="simpleSearchSelectedValue && simpleSearchSelectedValue.type === 'date'">-->
<!--                            <mat-label>Κριτήριο</mat-label>-->
<!--                            <input readonly matInput [matDatepicker]="picker" [(ngModel)]="searchValue">-->
<!--                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--                            <mat-datepicker #picker></mat-datepicker>-->
<!--                            &lt;!&ndash;                    <input [readonly]="displayEnrollments.data.length === 0" matInput [(ngModel)]="searchValue" (keydown)="fastSearch($event) ">&ndash;&gt;-->
<!--                        </mat-form-field>-->



<!--                    </div>-->
<!--                    <button mat-button mat-icon-button aria-label="search" (click)="search()">-->
<!--                        <mat-icon fxFlexAlign="center"  matTooltip="Αναζήτηση">search</mat-icon>-->
<!--                    </button>-->
<!--                    <button (click)="showSearchDialog()" mat-icon-button>-->
<!--                        <mat-icon fxFlexAlign="center"  matTooltip="Σύνθετη αναζήτηση">person_search</mat-icon>-->
<!--                    </button>-->
<!--                </div>-->
<!--                <div *ngIf="!isSearchLoading && displayEnrollments.data.length > 0" fxLayout="row" fxFlex>-->
<!--                    <table mat-table [dataSource]="displayEnrollments" matSort class="mat-elevation-z0">-->

<!--                        &lt;!&ndash; Position Column &ndash;&gt;-->
<!--                        <ng-container matColumnDef="childDisplayName">-->
<!--                            <th mat-header-cell *matHeaderCellDef> Ον/Επώνυμο παιδιού </th>-->
<!--                            <td mat-cell *matCellDef="let element"> {{element.childDisplayName}} </td>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="className">-->
<!--                            <th mat-header-cell *matHeaderCellDef> Τάξη </th>-->
<!--                            <td mat-cell *matCellDef="let element"> {{element.className}} </td>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="level_description">-->
<!--                            <th mat-header-cell *matHeaderCellDef> Επίπεδο </th>-->
<!--                            <td mat-cell *matCellDef="let element"> {{element.level_description}} </td>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="fatherDisplayName">-->
<!--                            <th mat-header-cell *matHeaderCellDef> Ον/Επώνυμο πατέρα </th>-->
<!--                            <td mat-cell *matCellDef="let element"> {{element.fatherDisplayName}} </td>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="motherDisplayName">-->
<!--                            <th mat-header-cell *matHeaderCellDef> Ον/Επώνυμο μητέρας </th>-->
<!--                            <td mat-cell *matCellDef="let element"> {{element.motherDisplayName}} </td>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="enroll_date">-->
<!--                            <th mat-header-cell *matHeaderCellDef> Ημερομηνία εγγραφής </th>-->
<!--                            <td mat-cell *matCellDef="let element"> {{element.enroll_date}} </td>-->
<!--                        </ng-container>-->



<!--                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>-->
<!--                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
<!--                    </table>-->
<!--                </div>-->
<!--                <div *ngIf="!isSearchLoading && displayEnrollments.data.length > 0" fxLayout="row" fxLayoutAlign="center center center">-->
<!--                    <mat-paginator [length]="resultLength" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]">-->
<!--                    </mat-paginator>-->
<!--                </div>-->

<!--                <div *ngIf="isLoading">-->
<!--                    <app-loading></app-loading>-->
<!--                </div>-->

<!--                <div *ngIf="!isSearchLoading && displayEnrollments.data.length === 0">-->
<!--                    <div fxLayout="row" fxLayoutAlign="center center center" style="margin-top: 50px; font-family: 'Century Gothic', sans-serif; font-size: 20px; color: gray">-->
<!--                        Δεν υπάρχουν εγγραφές-->
<!--                    </div>-->
<!--                </div>-->

            </div>
        </div>
    </ng-template>

</div>
